export default __webpack_public_path__ + "media/images/symbols/chevron-ab4420949971123031e8d8dcbf8e66f2.svg";